// extracted by mini-css-extract-plugin
export default {"loaderPrimary":"LoaderPrimary_loaderPrimary__r5Jq1"};